/**
 * Mapping of control type keys to component names for DynamicField.
 */
export const controlTypes = {
    json: 'file-upload-field',
    string: 'text-field',
    number: 'number-field',
    textarea: 'text-area-field',
    'code-editor': 'code-editor-field',
    boolean: 'boolean-field',
    toggle: 'toggle-field',
    password: 'password-field',
    'multi-select': 'multi-select-field',
    'one-select': 'one-select-field',
    'table-multi-select': 'table-multi-select-field',
    'table-one-select': 'table-one-select-field',
    slider: 'slider-field',
    datetime: 'date-time-picker-field',
    'child-form': 'child-form'
};
